// utils/formatInWords.js

/**
 * Converts a number into words using Indian units (Lakhs, Crores).
 * @param {number} amount - The amount to convert.
 * @returns {string} Formatted string like "2.5 Lakhs" or "3.2 Crores"
 */
export function formatToWords(amount) {
    if (typeof amount !== 'number' || isNaN(amount)) return '';
  
    if (amount >= 1e7) {
      return `${(amount / 1e7).toFixed(2)} Cr`;
    } else if (amount >= 1e5) {
      if (amount === 1e5){
        return `${(amount / 1e5).toFixed(2)} Lakh`;
      }
      else{
        return `${(amount / 1e5).toFixed(2)} Lakhs`;
      }
      
    } else if (amount >= 1e3) {
      return `${(amount / 1e3).toFixed(2)} Thousand`;
    } else {
      return amount.toString();
    }
  }

  export function formatInWords(amount) {
    if (isNaN(amount) || amount === 0) return "₹ Zero";
  
    const ones = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"];
    const teens = ["Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
    const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
  
    function twoDigitToWords(n) {
      if (n < 10) return ones[n];
      if (n < 20) return teens[n - 10];
      return tens[Math.floor(n / 10)] + (n % 10 ? " " + ones[n % 10] : "");
    }
  
    const denominations = [
      { name: "Kharab", plural: "Kharab", value: 1e11 },
      { name: "Arab", plural: "Arab", value: 1e9 },
      { name: "Cr", plural: "Cr", value: 1e7 },
      { name: "Lakh", plural: "Lakhs", value: 1e5 },
      { name: "Thousand", plural: "Thousand", value: 1e3 },
      { name: "Hundred", plural: "Hundred", value: 1e2 }
    ];
  
    let n = Math.floor(amount);
    const words = [];
  
    for (const { name, plural, value } of denominations) {
      const count = Math.floor(n / value);
      if (count > 0) {
        words.push(`${twoDigitToWords(count)} ${count > 1 ? plural : name}`);
        n %= value;
      }
    }
  
    if (n > 0) {
      words.push(twoDigitToWords(n));
    }
  
    return "₹ " + words.join(", ");
  }
  
  
  
